<p-toast key="ajustements"></p-toast>

<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 my-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>



<div #contenu *ngIf="EstCharge()">

    <div class="col-12">
        <p-card>
            <div class="grid">
                <div class="col-12 text-right mt-3">
                    <button pButton pRipple label="Nouvel ajustement" icon="pi pi-plus" class="p-button-text"
                        (click)="ajouter()"></button>
                </div>
            </div>
                    <div class="fluid formgrid grid">
                        <div class="col-12">
                            <p-table #dt [value]="ajustements"
                                dataKey="ajustementHeuresId" autoLayout="true" tableStyleClass="tableNormale"
                                styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true" >
                                <ng-template pTemplate="caption">
                                    <div class="flex align-content-center justify-content-between">
                                        <div>
                                        </div>
                                        <div>
                                            <h5 class="titreTableau m-0">Ajustements</h5>
                                        </div>
                                        <div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                    <th>Date</th>
                                    <th>Kms avant</th>
                                    <th>Kms après</th>
                                    <th>Ajustement</th>
                                    <th style="min-width: 7rem; width: 7rem;"></th>
                                </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-ajustement let-columns="columns">
                                    <tr>
                                        <td>{{ajustement.date | date:'yyyy-MM-dd'}}</td>
                                        <td>{{ajustement.nbKmsAvant}}</td>
                                        <td>{{ajustement.nbKmsApres}}</td>
                                        <td>{{ajustement.nbKms}}</td>
                                        <td></td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="4">Aucun ajustement.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                    <div class="grid">
                        <div class="col-12 text-right mt-3">
                            <button pButton pRipple label="Fermer" icon="pi pi-ban" class="p-button-text"
                                (click)="fermer()"></button>
                        </div>
                    </div>

        </p-card>
    </div>

</div>